export default __webpack_public_path__ + "static/media/petal_s1.c852f521.svg";